export default __webpack_public_path__ + "static/media/logo-light.91b20c3f.png";